import React from 'react';
import { Button, HStack } from '@chakra-ui/react';

const CHIP_HEIGHT = { base: '36px', md: '32px' } as const;

interface CitedPageChipsProps {
	pages: number[];
	/** Opens the document fullscreen at the given page. */
	onOpenPage: (page: number) => void;
}

/**
 * One chip per cited page. Each chip opens the document fullscreen at that page, so there is no
 * selected page state to track.
 */
const CitedPageChips: React.FC<CitedPageChipsProps> = (props: CitedPageChipsProps) => {
	const { pages, onOpenPage } = props;

	if (pages.length === 0) return null;

	return (
		<HStack gap={1.5} wrap="wrap">
			{pages.map((page) => (
				<Button
					key={page}
					type="button"
					h={CHIP_HEIGHT}
					minW="auto"
					px={4}
					borderRadius="full"
					borderWidth="1px"
					borderColor="border.default"
					variant="plain"
					bg="surface.default"
					color="brand.fg"
					boxShadow="xs"
					fontSize="sm"
					fontWeight="semibold"
					lineHeight="1"
					onClick={(event) => {
						event.preventDefault();
						event.stopPropagation();
						onOpenPage(page);
					}}
					_hover={{ bg: 'brand.muted' }}
				>
					p.{page}
				</Button>
			))}
		</HStack>
	);
};

export default CitedPageChips;
